import React from 'react';
import Modal from '../../../../../components/Modal/Modal';
import InfoTable from '../../../../../components/table/InfoTable';
import Img from '../../../../../components/Img/Img';
import Anchor from '../../../../../components/link/Anchor';
import { setNumberWithComma } from '../../../../../lib/common';
import { setDateFormat } from '../../../../../lib/moment';
import { PRODUCT_STATUS_TEXT } from '../../../../../constants/service/app/productConstants';
import './ExcelUploadCouponProductValidSuccessModal.scss';

const ExcelUploadCouponProductValidSuccessModal = (props) => {
  const { isOpen, data, onSubmit, closeModal, getProductSubCategoryList } = props;
  const { productList, requestCnt, possibleCnt, impossibleCnt } = data;

  return (
    <Modal
      title="쿠폰 사용 가능한 상품 엑셀 업로드 가능"
      isOpen={isOpen}
      width={1550}
      height={600}
      isFooter={true}
      okText="업로드하기"
      onOk={() => onSubmit()}
      onClose={() => closeModal()}
    >
      <div className="excel-upload-coupon-product-valid-success-modal-wrap">
        <div className="excel-upload-coupon-product-valid-success-title">
          <div className="summary">
            <span className="request">
              요청:
              <span>{requestCnt}</span>
            </span>
            <span className="possible">
              가능:
              <span>{possibleCnt}</span>
            </span>
            <span className="impossible">
              불가능:
              <span>{impossibleCnt}</span>
            </span>
          </div>

          <div>모든 요청이 엑셀 업로드가 가능합니다.</div>
        </div>

        <div className="excel-upload-coupon-product-valid-success-list-section">
          <InfoTable>
            <thead>
              <tr>
                <th>순번</th>
                <th>이미지</th>
                <th>브랜드명</th>
                <th>브랜드 ID</th>
                <th>상품 번호</th>
                <th>1차 카테고리</th>
                <th>2차 카테고리</th>
                <th>상태</th>
                <th>상품명</th>
                <th>판매가 (원)</th>
                <th>할인가 (원)</th>
                <th>할인율 (%)</th>
                <th>할인기간</th>
                <th>실판매가 (원)</th>
                <th>등록일</th>
                <th>쿠폰적용가격</th>
                <th>쿠폰적용할인액</th>
              </tr>
            </thead>
            <tbody>
              {productList.map((item, index) => (
                <tr key={index}>
                  <td className="tc">{index + 1}</td>
                  <td className="tc">
                    <Img src={item.url} width={'60px'} height={'60px'} />
                  </td>
                  <td className="tc">{item.storeName}</td>
                  <td className="tc">{item.storeId}</td>
                  <td className="tc">{item.productId}</td>
                  <td className="tc">{item.mainCategory}</td>
                  <td className="tc">
                    {item.isSubCategoryExists ? (
                      <Anchor
                        text="카테고리 보기"
                        isUnderLine
                        color="primary"
                        onClick={() =>
                          getProductSubCategoryList({
                            productId: item.productId,
                          })
                        }
                      />
                    ) : (
                      '-'
                    )}
                  </td>
                  <td className="tc">{PRODUCT_STATUS_TEXT[item.productStatus]}</td>
                  <td className="tc">{item.productName}</td>
                  <td className="tc">{setNumberWithComma(item.originPrice)}</td>
                  <td className="tc">{setNumberWithComma(item.discountPrice)}</td>
                  <td className="tc">{item.discountRate}</td>
                  <td className="tc">{item.discountPeriod}</td>
                  <td className="tc">{setNumberWithComma(item.salesPrice)}</td>
                  <td className="tc">{setDateFormat(item.createDate)}</td>
                  <td className="tc">{setNumberWithComma(item.couponApplyPrice)}</td>
                  <td className="tc">{setNumberWithComma(item.couponApplyDiscountAmount)}</td>
                </tr>
              ))}
            </tbody>
          </InfoTable>
        </div>
      </div>
    </Modal>
  );
};

export default ExcelUploadCouponProductValidSuccessModal;
